"use client";

import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import React from "react";

import { CookieConsentProvider } from "./CookieConsentProvider";

/**
 *   This file is a client component because the ContentfulLivePreviewProvider relies on React context.
 *   Wrapping children here does NOT force them into the client bundle –
 *   only components marked with "use client" below will be hydrated on the client.
 */

export default function Providers({
  preview,
  children,
}: {
  preview: boolean;
  children: React.ReactNode;
}) {
  return (
    <>
      <CookieConsentProvider />
      <ContentfulLivePreviewProvider
        locale="sv-SE"
        enableInspectorMode={preview}
        enableLiveUpdates={preview}
      >
        {children}
      </ContentfulLivePreviewProvider>
    </>
  );
}
